import * as Yup from "yup";

/**
 * Function: getRevitPluginVersionSchema
 *
 * This function returns a validation schema for the Revit Plugin Version form using Yup. The schema is used to ensure that
 * the input data for creating or editing a Revit Plugin Version is correctly formatted and meets the required constraints.
 *
 * Returns:
 * @returns {Yup.ObjectSchema} The Yup validation schema for the Revit Plugin Version form.
 */

export const getGenericMediaSchema = () => {
  const revitPluginVersionSchema = Yup.object().shape({
    name: Yup.string().max(100).optional(),
  });

  return revitPluginVersionSchema;
};
